export default __webpack_public_path__ + "static/tile-anatomy-light-de48b37e73b89a9c0678d8a9047b61c90486d81873f524a250f9aa3b6238d6af.png";